module.exports = __webpack_public_path__ + "static/16-travel-case 1-8f7634e65aeda8629f9c682b30cbb229.svg";